import { AdminPriceState, adminPriceTableRow } from "../types/index"
import { adminPriceMockData } from "../data"

export const initialState: AdminPriceState ={
    loading: false,
    priceData: adminPriceMockData,
    error:"",
}